export default "__VITE_ASSET__3ea340e5__"